import React from 'react';
import { CheckIcon } from 'lucide-react';
interface StepIndicatorProps {
  current: 1 | 2 | 3;
}
const steps = ['Select AUS', 'Review', 'Results'];
export function StepIndicator({
  current
}: StepIndicatorProps) {
  return <nav aria-label="Submission progress" data-id="element-284" data-mp="3toe5biq8fb7d">
      <ol className="flex flex-wrap items-center gap-x-3 gap-y-2" data-id="element-285" data-mp="3tl8jqdgtarge">
        {steps.map((label, index) => {
        const step = index + 1;
        const isComplete = step < current;
        const isActive = step === current;
        return <li key={label} className="flex items-center gap-3" data-id="element-286" data-mp="v44kpqagsyf2" data-mpi={index}>
              <div className="flex items-center gap-2" data-id="element-287" data-mp="h5y2fii0170i">
                <span className={`flex h-6 w-6 items-center justify-center rounded-full text-[11px] font-semibold transition-colors ${isComplete ? 'bg-emerald-600 text-white' : isActive ? 'bg-slate-900 text-white' : 'bg-slate-200 text-slate-500'}`} data-id="element-288" data-mp="h5eosdzdt4sa">
                  {isComplete ? <CheckIcon className="h-3.5 w-3.5" data-id="element-289" data-mp="2nvp6rr6h8oll" /> : step}
                </span>
                <span className={`text-sm ${isActive ? 'font-semibold text-slate-900' : 'text-slate-500'}`} aria-current={isActive ? 'step' : undefined} data-id="element-290" data-mp="2nxs7p6964253">
                  {label}
                </span>
              </div>
              {step < steps.length && <span aria-hidden="true" className="h-px w-8 bg-slate-200 sm:w-12" data-id="element-291" data-mp="36tic104kpam5" />}
            </li>;
      })}
      </ol>
    </nav>;
}